import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import {
  getTermsAndConditions,
  setTermAndCondition,
  addTermAndCondition,
  updateTermAndConditionById,
  removeTermAndCondition,
  setPagination
} from "../../../modules/termsandconditions";

import { setDispatchesView } from "../../../modules/settings";
import { setStatus, setCreatedByMe } from "../../../modules/search";
import { Row, Col, Spin, Table, Button, Input, Icon, Tag } from "antd";
import SearchBox from "./SearchBox";
import moment from "moment";
import _ from "lodash";
import ActionButtons from "../../ActionButtons";
import Boat from "../../../assets/boat.svg";
import Trailer from "../../../assets/trailer.svg";
import Airplane from "../../../assets/airplane.svg";

import "../index.css";

class DispatchList extends Component {
  state = {
    searchText: "",
    searchedColumn: ""
  };

  componentDidMount() {
    this.mounted = true;
    this.target = window.document.querySelector(".rightside");
    this.props.getTermsAndConditions();
  }

  componentWillUnmount() {
    this.mounted = false;
  }

  getItems() {
    let filteredItems = this.props.items;

    if (this.props.type && this.props.type.length) {
      filteredItems = _.filter(
        filteredItems,
        item => item.type && this.props.type.includes(item.type.id)
      );
    }

    return filteredItems;
  }

  getColumnSearchProps = dataIndex => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={node => {
            this.searchInput = node;
          }}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={e =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() =>
            this.handleSearch(selectedKeys, confirm, dataIndex)
          }
          style={{ width: 188, marginBottom: 8, display: "block" }}
        />
        <Button
          type="primary"
          onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
          icon="search"
          size="small"
          style={{ width: 90, marginRight: 8 }}
        >
          Search
        </Button>
        <Button
          onClick={() => this.handleReset(clearFilters)}
          size="small"
          style={{ width: 90 }}
        >
          Reset
        </Button>
      </div>
    ),
    filterIcon: filtered => (
      <Icon type="search" style={{ color: filtered ? "#1890ff" : undefined }} />
    ),
    onFilter: (value, record) => {
      if (dataIndex.includes(".")) {
        const split = dataIndex.split(".");

        if (record[split[0]]) {
          return record[split[0]][split[1]]
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase());
        }
      } else {
        return record[dataIndex]
          .toString()
          .toLowerCase()
          .includes(value.toLowerCase());
      }
    },
    onFilterDropdownVisibleChange: visible => {
      if (visible) {
        setTimeout(() => this.searchInput.select());
      }
    }
  });

  handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    this.setState({
      searchText: selectedKeys[0],
      searchedColumn: dataIndex
    });
  };

  handleReset = clearFilters => {
    clearFilters();
    this.setState({ searchText: "" });
  };

  handlePagination = (page, size) => {
    this.props.setPagination(page, size || 10);
  };

  componentWillReceiveProps(nextProps) {
    if (this.props.query !== nextProps.query) {
      if (!nextProps.query && this.state.fetchOnClear) {
        this.setState({ fetchOnClear: false }, () => {
          this.search();
        });
      } else if (nextProps.query) {
        this.setState({ fetchOnClear: true }, () => {
          this.search();
        });
      }
    }

    if (this.props.range !== nextProps.range) {
      this.search();
    }
  }

  search = _.debounce(() => {
    this.props.getTermsAndConditions(this.props.page, this.props.pageSize);
  }, 500);

  render() {
    const items = this.getItems();
    const total = items.length || 0;
    const colLg = { offset: 0, span: 24 };

    const colXl = colLg;
    const columns = [
      {
        title: "Nombre",
        dataIndex: "name",
        key: "name",
        width: 500,
        render: name => name
      },
      {
        title: "Fecha de creación",
        dataIndex: "createdAt",
        key: "createdAt",
        width: 250,
        render: createdAt => moment(createdAt).format("lll"),
        sorter: (a, b) =>
          moment(a.createdAt).unix() - moment(b.createdAt).unix()
      },
      {
        title: "Vigencia",
        dataIndex: "dueDate",
        key: "dueDate",
        width: 250,
        render: dueDate => moment(dueDate).format("lll"),
        sorter: (a, b) => moment(a.dueDate).unix() - moment(b.dueDate).unix()
      },
      {
        title: "Version",
        dataIndex: "version",
        key: "version",
        width: 150,
        render: version => version,
        className: "tablecolumns"
      },
      {
        title: "Tipo",
        dataIndex: "type",
        key: "type",
        width: 250,
        render: (text, record) => {
          const icons = {
            Marítimo: Boat,
            Terrestre: Trailer,
            Aereo: Airplane,
            LCL: Trailer
          };
          return (
            <Tag
              style={{
                backgroundColor: record.type.icon,
                color: "#fff",
                padding: 5,
                minWidth: "100px",
                textAlign: "center"
              }}
            >
              <img
                src={icons[record.type.name]}
                style={{ color: "#fff", marginRight: 8 }}
                alt="icon"
              />
              {record.type.name}
            </Tag>
          );
        }
      },
      {
        title: "Controles",
        dataIndex: "controles",
        key: "controles",
        fixed: "right",
        width: 200,
        render: (text, record) => {
          return <ActionButtons {...this.props} id={record.id} />;
        }
      }
    ];

    return (
      <div>
        <Row gutter={10} style={{ marginBottom: 10 }}>
          <Col lg={colLg} xl={colXl}>
            <SearchBox items={_.map(items, "id")} total={total} />
          </Col>
        </Row>
        {!this.props.fetching && total >= 1 && (
          <Row gutter={10} style={{ marginTop: 10, marginBottom: 10 }}>
            <Col style={{ display: "flex" }} lg={colLg} xl={colXl}>
              <span>
                Se obtuv{total > 1 ? "ieron" : "o"} {total} resultado
                {total > 1 ? "s" : ""}.
              </span>
            </Col>
          </Row>
        )}
        {this.props.fetching && total < 1 && (
          <div style={{ textAlign: "center", marginTop: 15, marginBottom: 15 }}>
            <Spin spinning />
          </div>
        )}
        {Boolean(total) && (
          <Row gutter={10}>
            <Col lg={colLg} xl={colXl}>
              <Table
                rowKey={"id"}
                scroll={{ x: 1300 }}
                style={{ backgroundColor: "#fff" }}
                pagination={{
                  total: this.props.pagination.total,
                  pageSize: this.props.pagination.pageSize,
                  current: this.props.pagination.page,
                  onChange: page => this.handlePagination(page)
                }}
                loading={this.props.fetching}
                columns={columns}
                dataSource={items}
                onRow={record => {
                  return {
                    onClick: row => {
                      this.props.setTermAndCondition(record.id, record);
                    }
                  };
                }}
              />
            </Col>
          </Row>
        )}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  user: state.auth.user,
  unauthorized: state.auth.unauthorized,
  fetching: state.termsandconditions.fetching,
  items: state.termsandconditions.items,
  selected: state.termsandconditions.selected,
  query: state.search.query,
  type: state.search.type,
  createdByMe: state.search.createdByMe,
  status: state.search.status,
  dispatchesView: state.settings.dispatchesView,
  record: state.termsandconditions.record,
  pagination: state.termsandconditions.pagination
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      getTermsAndConditions,
      setTermAndCondition,
      addTermAndCondition,
      updateTermAndConditionById,
      removeTermAndCondition,
      setDispatchesView,
      setCreatedByMe,
      setStatus,
      setPagination
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DispatchList);



// WEBPACK FOOTER //
// ./src/containers/TermsAndConditionsView/components/List.js